/* eslint-disable camelcase */

import React from 'react'

// Local import
import { updateErrors } from '../SectionField'
import TrashCanIcon from '../../ui/icons/TrashCanIcon'
import DuplicateIcon from '../../ui/icons/DuplicateIcon'
import SelectField from '../BasicFields/SelectField'

class ContentVariable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: props.question.id,
      context: props.question.context,
      position: props.question.position,
      variable_id: props.question.variable_id,
      errors: props.question.errors || {}
    }
  }

  shouldComponentUpdate(_nextProps, nextState) {
    this.state.errors = updateErrors(this.state.errors, this.props.getErrors)

    return (
      this.state.variable_id !== nextState.variable_id ||
      this.state.position !== nextState.position ||
      this.state.errors.isNew === true
    )
  }

  componentDidUpdate() {
    this.props.handleQuestionChange(this.state)
  }

  handleChange = event => this.setState({ [event.target.name]: event.target.value })

  render() {
    return (
      <div className="nested-fields ml-2 ml-md-4">
        <div className="d-flex">
          <div className="mr-auto">
            <i className="fas fa-arrows-alt c-pointer" {...this.props.dragHandleProps} />
            {' Variable '}
            <DuplicateIcon
              className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
              onClick={this.props.handleQuestionDuplicate(this.state.id)}
            />
          </div>
          <TrashCanIcon
            className="tw:text-gray-500 tw:hover:text-gray-700 c-pointer"
            onClick={this.props.handleQuestionRemove(this.state.id)}
          />
        </div>
        <SelectField
          name="variable_id"
          label="Variable"
          data={this.props.data.variables.filter(variable => variable.variable_type === 'text')}
          value={this.state.variable_id}
          errors={this.state.errors.variable}
          includeBlank
          onChange={this.handleChange}
        />
      </div>
    )
  }
}

export default ContentVariable
